function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_173"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_95",
  d: "M.984 1.966a6.036 6.036 0 0 0 6.053-6.045 6.036 6.036 0 0 0-6.053-6.046 6.036 6.036 0 0 0-6.052 6.046A6.036 6.036 0 0 0 .984 1.966",
  className: "cls-1",
  transform: "translate(5.068 10.125)"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_174",
  transform: "translate(1.721 10.159)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_96",
  d: "M0 0l.191 2.828L4.77 1.4c.147 0-1.031-.762-.879-.762",
  className: "cls-1"
}));

function SvgMenuIndicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "menu_indicator",
    viewBox: "0 0 12.104 12.987",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIndicator);
export default __webpack_public_path__ + "static/media/menu_indicator.2a863fa8.svg";
export { ForwardRef as ReactComponent };